module.exports = __webpack_public_path__ + "static/img/search.957ae710.png";